import React from 'react';
import styles from './styles.module.scss';

interface IHeaderProps {
  title: string;
  period: string;
}

const Header = ({ title, period }: IHeaderProps) => {
  return (
    <div data-testid="overview-header" className={styles.wrapper}>
      <div className={styles.middle}>
        <div className={styles.title}>{title}</div>
        <div className={styles.date}>{period}</div>
      </div>
    </div>
  );
};

export default Header;
